import DateRangePickerWidget from "../DatePicker/DateRangePickerWidget/DateRangePickerWidget.component.js";
import React from "react";
import { jsx } from "react/jsx-runtime";
import { useGridFilter } from "ag-grid-react";
import dayjs from "dayjs";
//#region src/TableDateColumnFilter/TableDateColumnFilter.tsx
const TableDateColumnFilter = ({ model, onModelChange, rowFilter, colDef, api }) => {
	const doesFilterPass = React.useCallback((node) => {
		if (model?.start == null || model?.end == null) return true;
		if (rowFilter) return rowFilter(model, node.data ?? {});
		const field = colDef.field ?? colDef.colId;
		if (!field || !node.data) return false;
		const raw = node.data[field];
		if (raw == null || raw === "" || raw === "—") return false;
		const date = typeof raw === "number" ? dayjs.unix(raw) : dayjs(raw);
		if (!date.isValid()) return false;
		const unix = date.unix();
		return unix >= model.start && unix <= model.end;
	}, [
		colDef.colId,
		colDef.field,
		model,
		rowFilter
	]);
	useGridFilter({ doesFilterPass });
	const handleRangeChange = (range) => {
		if (range.start === null && range.end === null) {
			const columnKey = colDef.colId ?? colDef.field;
			if (columnKey) api.destroyFilter(columnKey);
			api.hideColumnFilter();
			return;
		}
		onModelChange({
			start: range.start != null ? dayjs.unix(range.start).startOf("day").unix() : null,
			end: range.end != null ? dayjs.unix(range.end).endOf("day").unix() : null
		});
		api.hideColumnFilter();
	};
	return /* @__PURE__ */ jsx(DateRangePickerWidget, {
		value: model ?? void 0,
		onChange: handleRangeChange,
		withTime: colDef.filterParams?.withTime,
		size: "sm",
		clearable: true
	});
};
//#endregion
export { TableDateColumnFilter };

//# sourceMappingURL=TableDateColumnFilter.js.map